import { Box, Icon, Skeleton, type TextProps } from "@prismicio/editor-ui"

import type { Release } from "../../app/services/release"

interface ReleaseStatusIndicatorProps {
  release: Release | undefined
}

export function ReleaseStatusIndicator(props: ReleaseStatusIndicatorProps) {
  const { release } = props

  if (!release) return <Skeleton height={24} width={24} />

  const colors = getColors(release)

  return (
    <Box padding={4} backgroundColor={colors.background} borderRadius={6}>
      <Icon name="calendarToday" color={colors.icon} size="small" />
    </Box>
  )
}

type Color = TextProps["color"] // Color = ThemeKeys<"color">

interface IndicatorColors {
  icon: Color
  background: Color
}

function getColors(release: Release): IndicatorColors {
  if (release.migration) {
    return {
      icon: "purple11",
      background: "purple3"
    }
  }

  if (release.timestamp) {
    return {
      icon: "green11",
      background: "green3"
    }
  }

  return {
    icon: "tomato11",
    background: "tomato3"
  }
}
